/*
 * @Author: wangbaihe
 * @Date: 2023-06-20 14:55:13
 * @LastEditors: wangbaihe
 * @LastEditTime: 2024-09-10 17:24:21
 * @FilePath: \common-mediax\src\apis\MediaCloudSystem\Thirdparty.js
 * @Description: MediaCloudSystemThirdparty
 */
import { createAPI } from '@common'
export default {
  // 如果实用只能魔方
  getNewairCloudLogin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0fospmm0pqfo0ofxbjsdmpve0mphjo', 'GET', config),
  // 读已有列表
  getE5AdminClientsList: (config) =>
    createAPI('customEncryptApiName-1/0f60benjo0dmjfout0mjtu', 'GET', config),
  // 新建
  // postE5AdminClients: config => createAPI('customEncryptApiName-1/0f60benjo0dmjfout', 'POST', config),
  postE5AdminClients: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout', 'POST', config),
  // 修改
  updateE5AdminClients: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout', 'PUT', config),
  // 删除
  // deteteE5AdminClients: config => createAPI('customEncryptApiName-1/0f60benjo0dmjfout', 'DELETE', config),
  deleteE5AdminClients: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout', 'DELETE', config),
  // 读详情
  // getE5AdminClients: config => createAPI('customEncryptApiName-1/0f60benjo0dmjfout', 'GET', config),
  getE5AdminClients: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout', 'GET', config),

  // 获取三方子系统列表
  getClientsSubList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout0tvc0mjtu', 'GET', config),
  // 新增三方子系统
  getClientsSubAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout0tvc0bee', 'POST', config),
  // 修改三方子系统
  getClientsSubUpdate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout0tvc0vqebuf', 'POST', config),
  // 删除三方子系统
  getClientsSubDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout0tvc0efmfuf', 'DELETE', config),

  // 获取可显示的三方url BUG #524747
  /* getClientMenu: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0dmjfout0nfovft', 'GET', config), */
  pushThird: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0bsujdmf0uw0qvtiUijse', 'GET', config),
  getClientMenu: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0dmjfout0nfovft', 'GET', config),
  // 读权限（一个角色对某个三方系统的权限）
  getE5AdminPermissionsClient: (config) =>
    createAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0dmjfou', 'GET', config),
  // 设置权限（一个角色对某个三方系统的权限）
  postE5AdminPermissionsClient: (config) =>
    createAPI('customEncryptApiName-1/0f60benjo0qfsnjttjpot0dmjfou', 'POST', config),
  // 子系统接口 - 读已有列表
  getE5AdminClientsTenantsList: (config) =>
    createAPI('customEncryptApiName-1/0w20benjo0dmjfout0ufobout0mjtu', 'GET', config),
  // 子系统接口 - 新建
  postE5AdminClientsTenants: (config) =>
    createAPI('customEncryptApiName-1/0w20benjo0dmjfout0ufobout', 'POST', config),
  // 子系统接口 - 修改
  putE5AdminClientsTenants: (config) =>
    createAPI('customEncryptApiName-1/0w20benjo0dmjfout0ufobout', 'PUT', config),
  // 子系统接口 - 删除
  deleteE5AdminClientsTenants: (config) =>
    createAPI('customEncryptApiName-1/0w20benjo0dmjfout0ufobout', 'DELETE', config),
  // 获取关联ID
  getRelationDestId: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0sfmbujpo0hfuEftuJe', 'GET', config),

  // 读分类（分组）树
  getAdminCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60benjo0dbut', 'GET', config),
  // 获取操作名称
  getChannelOperateName: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0puifs0diboofm0pqfsbufObnf', 'GET', config),
  // 获取操作名称
  postChannelOperateName: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0puifs0diboofm0pqfsbufObnf', 'POST', config),
  // 添加分类（分组）
  postAdminCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60benjo0dbut', 'POST', config),
  // 修改分类（分组）
  putAdminCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60benjo0dbut', 'PUT', config),
  // 删除分类（分组）
  deleteAdminCats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60benjo0dbut', 'DELETE', config),
  // 新建/修改渠道
  postOtherChannel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0puifs0diboofm', 'POST', config),
  // 读渠道详情
  getOtherChannel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0puifs0diboofm', 'GET', config),
  // 删除渠道
  deleteOtherChannel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0puifs0diboofm', 'DELETE', config),
  // 流程记录
  getE5ActionsLogs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0f60bdujpot0mpht', 'get', config, vconfig),
  // 流程记录
  getOtherChannelList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0puifs0diboofm0mjtu', 'get', config, vconfig),
  // 三方渠道推送
  postOtherChannelPush: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0puifs0diboofm0qvti', 'post', config, vconfig),
  // 新建 三方审校
  postThirdProofAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0qsppg0bee', 'POST', config),
  // 修改 三方审校
  postThirdProofUpdate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0qsppg0vqebuf', 'POST', config),
  // 查看 三方审校详情
  postThirdProofDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0qsppg0efubjm', 'POST', config),
  // 删除 三方审校
  postThirdProofDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0pqfo0qsppg0efmfuf', 'POST', config),
  // 获取稿内投票（新空云投票列表）
  getInnerVoteList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0fospmm0ofxbjsdmpve0wpufMjtu', 'get', config, vconfig),
  // 获取新空云的配置
  getNacVoteConfig: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0fospmm0hfuObdWpufDpogjh', 'get', config, vconfig),
  // 稿内投票登录（新空云投票）
  innerVoteLogin: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0fospmm0wpuf0ofxbjsdmpve0mphjo', 'get', config, vconfig)
}
